<template>
  <div>
    <div class="mainInput" :class="classes">
      <div v-if="title != ''" :class="labelClass" class="labelStyle" :style="title.length > 12 ? `whiteSpace: nowrap; font-size: 12px` : { whiteSpace: 'none' }">{{ title }}</div>
      <div class="w-100 position-relative">
        <vue-slider ref="slider" v-model="inputVal" v-bind="sliderOptions" @drag-end="RateValue(inputVal)"></vue-slider>
        <div v-if="showError" class="errorClass">{{ errortext }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRangeSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    vueSlider: VueRangeSlider,
  },
  data() {
    return {
      sliderOptions: {
        text: '',
        dotSize: 0,
        width: '100%',
        height: 7,
        contained: false,
        direction: 'rtl',
        dataLabel: 'label',
        dataValue: 'value',
        min: 0,
        max: 10,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 1,
        adsorb: false,
        lazy: true,
        tooltip: 'always',
        tooltipPlacement: 'top',
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: true,
        enableCross: true,
        fixed: false,
        order: true,
        marks: {
          '0': '0',
          '10': '10',
        },
        process: true,
        processStyle: { backgroundColor: '#556ee6' },
        tooltipStyle: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
    }
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    isPrice: {
      default: false,
      type: Boolean,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    id: {
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errortext: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    options: {
      text: {
        type: String,
        default: 'رضایت از مشتری',
      },
      dotSize: {
        type: Number,
        default: 0,
      },
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: Number,
        default: 0,
      },
      contained: {
        type: Boolean,
        default: false,
      },
      direction: {
        type: String,
        default: 'rtl',
      },
      data: {
        type: Array,
        default: null,
      },
      dataLabel: {
        type: String,
        default: 'label',
      },
      dataValue: {
        type: String,
        default: 'value',
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 10,
      },
      interval: {
        type: Number,
        default: 1,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      clickable: {
        type: Boolean,
        default: true,
      },
      duration: {
        type: Number,
        default: 1,
      },
      adsorb: {
        type: Boolean,
        default: false,
      },
      lazy: {
        type: Boolean,
        default: true,
      },
      tooltip: {
        type: String,
        default: 'always',
      },
      tooltipPlacement: {
        type: String,
        default: 'top',
      },
      tooltipFormatter: {
        default: null,
      },
      useKeyboard: {
        type: Boolean,
        default: false,
      },
      keydownHook: null,
      dragOnClick: {
        type: Boolean,
        default: true,
      },
      enableCross: {
        type: Boolean,
        default: true,
      },
      fixed: {
        type: Boolean,
        default: false,
      },
      minRange: {
        default: null,
      },
      maxRange: {
        default: null,
      },
      order: {
        type: Boolean,
        default: true,
      },
      marks: {
        type: Object,
        default: {
          '0': '0',
          '10': '10',
        },
      },
      dotOptions: {
        default: null,
      },
      dotAttrs: {
        default: null,
      },
      process: {
        type: Boolean,
        default: true,
      },
      dotStyle: {
        default: null,
      },
      railStyle: {
        default: null,
      },
      processStyle: {
        type: Object,
        default: { backgroundColor: '#556ee6' },
      },
      tooltipStyle: {
        type: Object,
        default: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
      stepStyle: {
        default: null,
      },
      stepActiveStyle: {
        default: null,
      },
      labelStyle: {
        default: null,
      },
      labelActiveStyle: {
        default: null,
      },
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        if (val.length > 0) {
          this.showError = false
        }
        this.$emit('input', val)
      },
    },
  },
  methods: {
    RateValue() {
      this.$emit('rate', this.modelValue)
    },
  },
}
</script>

<style scoped>
.p-card {
  background-color: transparent !important;
}
#wrap {
  padding: 0 !important;
}
.labelsMinMax {
  display: flex;
  justify-content: space-between;
}
.p-card-body {
  padding: 0 !important ;
}
.mainInput {
  display: flex;
  align-items: center;
}
.inputStyle {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
.disableInput {
  width: 100%;
  color: #c6cbd0;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorStyle {
  line-height: 17px;
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #fe5e61;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorClass {
  position: absolute;
  bottom: -16px;
  font-size: 10px;
  color: #fe5e61;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
.labelStyle {
  min-width: 90px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
